import React, { useState } from 'react'
import { AntTabs, AntTab } from './common/Tabs'
import { DashboardAthenaTable } from './DashboardAthenaTable'
import {
  candidateLicensesCols,
  candidateCompetenciesCols,
  candidateEducationCols
} from '../constants/CandidateCols'
import { resourceEmploymentHistoryCols } from '../constants/ResourceCols'

const tabs = [
  { display: 'Licenses/Credentials', value: 0 },
  { display: 'Competencies/Skills', value: 1 },
  { display: 'Education', value: 2 },
  { display: 'Employment History', value: 3 }
]

export default function CandidateTalentProfile(props) {
  const [value, setValue] = useState(0)
  const { headers, tableRefreshKey } = props

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <>
      <AntTabs
        color={props.fetchInitialData.credentials.primaryAppColor}
        value={value}
        onChange={handleChange}
        aria-label='talent profile tabs'
      >
        {tabs.map((cur, index) => (
          <AntTab
            key={index}
            label={cur.display}
            value={cur.value}
            color={props.fetchInitialData.credentials.primaryAppColor}
          />
        ))}
      </AntTabs>
      {value === 0 && (
        <div style={{ marginTop: '1rem' }}>
          <DashboardAthenaTable
            {...props}
            isTempTable={false}
            key={`licenses-${tableRefreshKey}`}
            params={{ ...headers }}
            tableColumns={candidateLicensesCols}
            reportName='hr_candidate_talent_licenses'
          />
        </div>
      )}
      {value === 1 && (
        <div style={{ marginTop: '1rem' }}>
          <DashboardAthenaTable
            {...props}
            isTempTable={false}
            key={`competencies-${tableRefreshKey}`}
            params={{ ...headers }}
            tableColumns={candidateCompetenciesCols}
            reportName='hr_candidate_talent_competencies'
          />
        </div>
      )}
      {value === 2 && (
        <div style={{ marginTop: '1rem' }}>
          <DashboardAthenaTable
            {...props}
            isTempTable={false}
            key={`education-${tableRefreshKey}`}
            params={{ ...headers }}
            tableColumns={candidateEducationCols}
            reportName='hr_candidate_talent_education'
          />
        </div>
      )}
      {value === 3 && (
        <div style={{ marginTop: '1rem' }}>
          <DashboardAthenaTable
            {...props}
            isTempTable={false}
            key={`employment-history-${tableRefreshKey}`}
            params={{ ...headers }}
            tableColumns={resourceEmploymentHistoryCols}
            reportName='hr_candidate_talent_employment_history'
          />
        </div>
      )}
    </>
  )
}
